export default __webpack_public_path__ + "static/media/notFoundSerch.cdf3d241.svg";